<template>
  <div id="content">
        <loader v-if="loading"></loader>
        <div class="mt-3" v-else>
            <b-table small striped hover bordered :items="data" :fields="['name', 'description','price', 'days', 'action']">
                <template v-slot:cell(name)="data">
                    {{data.value}}
                </template>
                <template v-slot:cell(description)="data">
                    {{data.value}}
                </template>
                <template v-slot:cell(price)="data">
                    {{data.value}}
                </template>
                <template v-slot:cell(days)="data">
                    {{data.value}}
                </template>
                <template v-slot:cell(action)="row">
                    <b-button size="sm" variant="primary" v-b-modal="String(row.item.id)">Edit</b-button>

                    <b-modal :busy="saving" :id="String(row.item.id)" title="Update Membership Price" @ok="() => update(row.item.id, form[row.index])" :disabled="saving">
                        <b-form @submit.prevent.stop="() => update(row.item.id, form[row.index])">
                            <b-form-group>
                                <b-form-input type="text" required placeholder="Name" v-model="form[row.index].name"></b-form-input>
                            </b-form-group>
                            <b-form-group>
                                <b-form-input type="text" required placeholder="Description" v-model="form[row.index].description"></b-form-input>
                            </b-form-group>
                            <b-form-group>
                                <b-form-input type="number" required placeholder="Price" v-model="form[row.index].price"></b-form-input>
                            </b-form-group>
                            <b-form-group>
                                <b-form-input type="number" required placeholder="Days" v-model="form[row.index].days"></b-form-input>
                            </b-form-group>
                        </b-form>
                    </b-modal>

                </template>
            </b-table>
        </div>
    </div>
</template>

<script>
import GetProtectionPrices from '../../../store/actions/getProtectionPrice';
import UpdateProtectionPrice from '../../../store/actions/updateProtectionPrice';
import ContentLoader from '../../../components/ContentLoader';
import ShowError from "../../../helpers/showError";

  export default {
    name: 'ProtectionPrice',
    components: {
      loader: ContentLoader
    },
    data() {
      return {
        data: [],
        saving: false,
        form: [],
        loading: true,
      }
    },
    created() {
      this.load();
    },
    methods: {
      async load(){
        try {
          this.loading = true;
          const result = await GetProtectionPrices();
          this.data = result;
          this.form = result;
        } catch (e) {
          ShowError(this, e);
        } finally {
          this.loading = false;
        }
      },
      async update(id, {name, description, price, days}){
        try {
          this.loading = true;
          await UpdateProtectionPrice(id, {name: String(name), description: String(description), price: Number(price), days: Number(days)});
          this.load();
        } catch (e) {
          ShowError(this, e);
        } finally {
          this.loading = false;
        }
      }
    }
  }

</script>
